<template>
  <div :class="setWrapperClass">
    <input
      class="checkbox__input" 
      :id="setId" 
      :name="setId" 
      :value="value"
      :checked="setChecked"
      type="checkbox"
      @change="saveData"
    >
    <label :for="setId" class="label checkbox__label">{{ this.label }}</label>
  </div>
</template>

<script>

export default {

  methods: {

    saveData(e) {

      var val = false;

      if ( e.target.checked ) {

        val = e.target.value;

      }

      if ( this.modal === 'true' ) {

        var modal = this.$store.getters.modalVars;

        if ( modal.component === 'printForm') {

          if ( val === 'true' ) {

            val = true;

          }

          else {

            val = false;
            
          }

          this.$store.dispatch('savePrintOption', {
            field: this.field,
            value: val,
          });

        }        

      }

      else {

        this.$store.dispatch('saveField', {
          field: this.field,
          value: val,
        });

      }

    }

  },
  
  computed: {

    setId() {

      return this.id;

    },

    setWrapperClass() {

      var c = 'checkbox-wrap';

      if (this.indent === 'true') {

        c += ' checkbox-wrap--indent';

      }

      return c;

    },

    setChecked() {

      if ( this.modal === 'true' ) {

        var modal = this.$store.getters.modalVars,
            val = false;

        if ( modal.component === 'printForm') {

          print = this.$store.getters.getPrintOptions;

          if ( print[this.field] ) {

            return true;

          }

        }

      }

      else {

        var val = this.$store.getters.getFieldData({ field: this.field });

      }

      if ( val === this.value ) {

        return true;

      }

      return false;

    }

  },

  props : [

    'label',
    'id',
    'field',
    'value',
    'modal',
    'indent',

  ],   

}

</script>

<style lang="scss">

  .checkbox-wrap {

    padding: .5rem 0;
    margin-bottom: 1rem;

    &.checkbox-wrap--indent {

      padding-left: 2rem;

    }

  }

  .checkbox__input {

    -webkit-appearance: none;
    border: 1px solid rgba(0, 0, 0, .04);
    font-size: .8rem;
    padding: .75rem;
    background: rgba(0, 0, 0, .05);
    width: 1.4rem;
    height: 1.4rem;
    border-radius: 2px;
    text-align: left;
    box-shadow: 0 0 4px rgba(0, 0, 0, .05);
    outline: none;
    margin-right: 6px;
    display: inline-block;
    vertical-align: top;
    position: relative;

    &:checked {

      &::after {

        transform: scale(1);

      }

    }

    &::after {

      content: '';
      position: absolute;
      background: #06a0df;
      display: block;
      top: 5px;
      left: 5px;
      right: 5px;
      bottom: 5px;
      border-radius: 1px;

      transform: scale(0);
      transition: transform .1s ease;

    }

  }

  .checkbox__label {

    display: inline-block;
    vertical-align: top;    
    width: auto;
    max-width: calc(100% - 50px);

  }

</style>



// WEBPACK FOOTER //
// Checkbox.vue?2c270691